<template>
  <v-row justify="center">
    <v-col
      cols="12"
      sm="10"
    >
      <base-material-card>
        <template v-slot:heading>
          <div class="subtitle-1 font-weight-light">
            Правило для Программы лояльности:
          </div>
          <div class="display-1 font-weight-light">
            {{ Campaign ? Campaign.name : "" }}
          </div>
          <div class="subtitle-1 font-weight-light">
            {{ Campaign ? Campaign.description : "" }}
          </div>
        </template>
        <!--        <v-card-title>{{ Rule.name }}</v-card-title>-->
        <!--        <v-card-subtitle>{{ Rule.description }}</v-card-subtitle>-->
        <!--        <v-divider></v-divider>-->
        <v-card-text>
          <div>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="Rule.name"
                  hint="Наименование правила"
                  label="Наименование"
                  placeholder="Наименование правила"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="Rule.chargeType"
                  :items="ruleChargeTypeList"
                  hint="Тип начисления (транзакционный, регулярный )"
                  item-text="text"
                  item-value="value"
                  label="Тип начисления"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="Rule.description"
                  hint="Описание правила"
                  label="Описание"
                  placeholder="Описание правила"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="Rule.operation"
                  :items="ruleOperationTypeList"
                  hint="Тип операции (покупка, платёж, регистрация, регулярный)"
                  label="Тип операции"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-if="Rule.accrualType === 0 || Rule.accrualType === 1"
                  v-model="Rule.accrualAmount"
                  hint="Сумма бонусов к начислению по операции"
                  label="Размер начисления"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="Rule.accrualType"
                  :items="ruleAccrualTypeList"
                  label="Тип начисления"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="Rule.bonusAccrualPeriod"
                  hint="Период начисления бонусов в днях, в какой момент фактически бонусы окажутся на клиентском счете"
                  label="Период начисления бонусов (в днях)"
                  placeholder="Период начисления бонусов в днях"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="Rule.bonusCancellationPeriod"
                  hint="Через какой период выполнится списание бонусных единиц (в днях), 0 если без периода."
                  label="Период обнуления бонусов (в днях)"
                  placeholder="Период обнуления бонусов (в днях)"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-switch
                  v-model="Rule.status"
                  :label="Rule.status ? 'Статус (Активный)' : 'Статус (Неактивный)'"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row
            align-content="space-between"
            justify="space-around"
          >
            <v-btn
              color="primary"
              outlined
              @click="back"
            >
              Назад
            </v-btn>
            <v-btn
              :disabled="newNameInvalid"
              color="primary"
              @click="Rule.ruleId > 0 ? save() : create()"
            >
              {{ Rule.ruleId > 0 ? "Сохранить" : "Создать" }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
import { getRuleAccrualTypeList, getRuleChargeTypeList, getRuleOperationTypeList, } from "../../shared/modules/utilities"
import WebApi from "../../shared/modules/web_api"
import RuleModel from "@/views/loyalty/models/rule.model"
import { CampaignModel } from "@/views/loyalty/models/campaign.model"

export default {
  name: "RuleEdit",
  data: () => ({
    Campaign: {},
    Rule: {},
    webApi: null
  }),
  computed: {
    ruleChargeTypeList () {
      return getRuleChargeTypeList()
    },
    ruleOperationTypeList () {
      return getRuleOperationTypeList()
    },
    ruleAccrualTypeList () {
      return getRuleAccrualTypeList()
    },
    newNameInvalid () {
      return !this.Rule.name || this.Campaign.campaignId <= 0
    }
  },
  beforeMount () {
    console.clear()
    // this.Rule = this.$store.getters["rule_store/getRule"];
    // this.Campaign = this.$store.getters["campaign_store/getCampaign"];
    const ruleId = +this.$route.params.ruleId
    const campaignId = +this.$route.params.campaignId

    this.webApi = new WebApi(this.$store)
        .createSuccess("Правило создано!")
        .createError("Произошла ошибка при создании Правила!")
        .editSuccess("Правило сохранено!")
        .editError("Произошла ошибка при сохранении Правила!")
    if (ruleId !== 0) {
      this.webApi
          .get(`${process.env.VUE_APP_LOYALTY_URL}rule/${ruleId}`)
          .then(data => {
            this.Rule = Reflect.construct(RuleModel, [data])
          })
    }
    this.webApi
        .get(`${process.env.VUE_APP_LOYALTY_URL}api/campaign/${campaignId}`)
        .then(data => {
          this.Campaign = Reflect.construct(CampaignModel, [data])
          if (ruleId === 0) {
            this.Rule = Reflect.construct(RuleModel, [])
            this.Rule.campaignId = this.Campaign.campaignId
          }
          console.log("this.Campaign", this.Campaign)
        })
    console.log(this.Rule)
  },
  methods: {
    create () {
      const data = Object.assign({}, this.Rule)
      const that = this
      console.log("create")
      this.webApi
          .post(`${process.env.VUE_APP_LOYALTY_URL}rule/`, data)
          .then(function (data) {
            console.log(data)
            that.Rule.ruleId = data.ruleId
          })
      this.back()
    },
    back () {
      this.$router.back()
    },
    save () {
      console.log("saving...")
      this.webApi
          .patch(
              `${process.env.VUE_APP_LOYALTY_URL}rule/` + this.Rule.ruleId,
              this.Rule
          )
          .then(function (response) {
            console.log(response)
          })
      this.back()
    }
  },
  // mounted() {
  //   console.log("this.Campaign", this.Campaign)
  //
  //   console.log("mounted this.Rule=", this.Rule)
  // }
}
</script>

<style scoped></style>
